import { observer } from 'mobx-react'
import React from 'react'
import { Button } from '../../atoms/Button'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import { GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
  } from '../../schema/schemaTypes'

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  no: number
  buttonLabel?: string
  children?: React.ReactChildren
}

export const IntakeStepButton = observer(
  ({ active, handleSubmit, intake, id, isCompleted, label, name, no, buttonLabel, children }: IProps) => (
    <IntakeStepContainer id={id} active={active}>
      <IntakeStepNoColTablet>
        <FieldNo checked={isCompleted}>{no}</FieldNo>
      </IntakeStepNoColTablet>
      <IntakeStepCol>
        <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
        {children}
        {/* tslint:disable-next-line:jsx-no-lambda */}
        <Button disabled={!active} style={{ marginTop: 25 }} onClick={() => handleSubmit({ [name]: true })}>
          {buttonLabel}</Button>
      </IntakeStepCol>
    </IntakeStepContainer>
  ))



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepButton.tsx